<script>
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
// import Swal from "sweetalert2";

import Layout from "../../layouts/main";
import appConfig from "../../../app.config";
// import PageHeader from "@/components/page-header";
import { workOrderList, exportWorkOrder,statisticsOrder } from "@/service";
import { getCompany } from "@/helpers/common-service";
import { formatDatetime, getTimezone } from "@/helpers/common";
import {
  WorkOrderStatus,
  WorkOrderPriority,
  WorkOrderWarrantyStatus,
  WO_TYPE,
  WO_TYPE_TXT,
  WO_STATUS_TO_BE_ASSIGNED,
  WO_STATUS_TO_BE_CONSTRUCTED,
  WO_TYPE_EQUIPMENT_QR_CODE,
} from "@/config/common";
import _ from "lodash";
import WoStatusEtc from "@/views/work-order/components/widgets/wo-status-etc";
import TableLoading from "@/views/widgets/table-loading";
import i18n from "@/i18n";
import feedbackFilter from "@/views/work-order/components/widgets/feedback-filter.vue";
import { CountTo } from "vue3-count-to";
const priorityOptions = _.cloneDeep(WorkOrderPriority);
priorityOptions.unshift({ value: "", label: i18n.global.t("page.all") });
const orderStatusOptions = _.cloneDeep(WorkOrderStatus);
orderStatusOptions.unshift({ value: "", label: i18n.global.t("page.all") });
let arr =  WO_TYPE.filter(item=>item.value != 5 ) //排除掉延保服务
const orderTypeOptions = _.cloneDeep(arr);
orderTypeOptions.unshift({ value: WO_TYPE_EQUIPMENT_QR_CODE, label: i18n.global.t("page.work-order.type.QR-code") });//增加贴二维码
orderTypeOptions.unshift({ value: "", label: i18n.global.t("page.all") });


let routeFrom = null;

export default {
  name: "work-order",
  page: {
    title: i18n.global.t("menu.after-sales_service.order.text"),
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      WO_TYPE,
      WO_TYPE_TXT,
      WO_TYPE_EQUIPMENT_QR_CODE,
      WorkOrderPriority,
      title: i18n.global.t("menu.after-sales_service.order.text"),
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      value: null,
      status: null,
      status1: "",
      checkTabVal: "0",
      tabOptions: JSON.parse(localStorage.getItem("user"))&&JSON.parse(localStorage.getItem("user")).user_type==='customer'?
          [
            {
              value: "0",
              text: this.$t("page.work-order.all-order"),
              icon: "ri-layout-grid-fill",
              tipNum: 0,
            },
            {
              value: "1",
              text: this.$t("page.work-order.status.pending"),
              icon: "ri-time-fill",
              tipNum: 0,
            },
            {
              value: "2",
              text: this.$t("page.work-order.status.under-construction"),
              icon: "ri-creative-commons-by-fill",
              tipNum: 0,
            },
            {
              value: "103",
              text: this.$t("page.work-order.status.awaiting-signature"),
              icon: "ri-file-edit-fill",
              tipNum: 0,
            },
            {
              value: "3",
              text: this.$t("page.work-order.status.completed"),
              icon: "ri-checkbox-circle-fill",
              tipNum: 0,
            },
            {
              value: "4",
              text: this.$t("page.work-order.status.canceled"),
              icon: "ri-close-circle-fill",
              tipNum: 0,
            }
          ]:[
            {
              value: "0",
              text: this.$t("page.work-order.all-order"),
              icon: "ri-layout-grid-fill",
              tipNum: 0,
            },
            {
              value: "1",// 待派工
              text: this.$t("page.work-order.status.to-be-assigned"),
              icon: "ri-time-fill",
              tipNum: 0,
            },
            {
              value: "101",// 待确认
              text: this.$t("page.work-order.status.unconfirmed"),
              icon: "ri-time-fill",
              tipNum: 0,
            },
            {
              value: "100", // 待转派
              text: this.$t("page.work-order.status.reassign"),
              icon: "ri-time-fill",
              tipNum: 0,
            },
            {
              value: "2",//待施工
              text: this.$t("page.work-order.status.pending-construction"),
              icon: "ri-creative-commons-by-fill",
              tipNum: 0,
            },
            {
              value: "102", // 施工中
              text: this.$t("page.work-order.status.under-construction"),
              icon: "ri-creative-commons-by-fill",
              tipNum: 0,
            },
            {
              value: "103",
              text: this.$t("page.work-order.status.awaiting-signature"),
              icon: "ri-file-edit-fill",
              tipNum: 0,
            },
            {
              value: "3",
              text: this.$t("page.work-order.status.completed"),
              icon: "ri-checkbox-circle-fill",
              tipNum: 0,
            },
            {
              value: "4",
              text: this.$t("page.work-order.status.canceled"),
              icon: "ri-close-circle-fill",
              tipNum: 0,
            },
          ],
      config: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      date2: null,
      priorityOptions,
      statusOptions: orderStatusOptions,
      warrantyOptions: WorkOrderWarrantyStatus,
      orderTypeOptions,
      showAllColumns: false,
      tableHeaders: [
        {
          name: "number",
          label: this.$t("page.work-order.number"),
          visible: true,
        },
        {
          name: "type",
          label: this.$t("page.work-order.type.text"),
          visible: true,
        },
        {
          name: "priority",
          label: this.$t("page.work-order.priority.text"),
          visible: true,
        },
        {
          name: "device_name",
          label: this.$t("page.work-order.device-name"),
          visible: true,
        },
        {
          name: "device_root_sn",
          label: this.$t("page.work-order.device-root-sn"),
          visible: true,
        },
        {
          name: "warranty_status",
          label: this.$t("page.work-order.warranty-status.text"),
          visible: false,
        },
        {
          name: "customer_contact_name",
          label: this.$t("page.work-order.contact"),
          visible: true,
        },
        {
          name: "customer_contact_number",
          label: this.$t("page.work-order.contact-phone"),
          visible: true,
        },
        {
          name: "status",
          label: this.$t("page.work-order.status.text"),
          visible: true,
        },
        {
          name: "customer_txt",
          label: this.$t("page.work-order.customer-name"),
          visible: JSON.parse(localStorage.getItem("user"))&&JSON.parse(localStorage.getItem("user")).user_type!=='customer',
        },
        {
          name: "service_company_txt",
          label:JSON.parse(localStorage.getItem("user"))&&JSON.parse(localStorage.getItem("user")).user_type==='customer'?this.$t("page.service-provider"):this.$t("page.service-company"),
          visible: true,
        },
        {
          name: "engineer",
          label: this.$t("page.engineer"),
          visible: true,
        },
        {
          name: "created_at",
          label: this.$t("page.create-time"),
          visible: true,
        },
      ],
      visibleFields: [], // 显示的字段，按点击的顺序展示
      tableLoading: false,
      tableLoaded: false,
      orders: [],
      count: 0,
      filters: {
        page: 1,
        page_size: 10,
      },
      filter_value: {
        keyword: "",
        date: null,
        priority: null,
        status: "0",
        is_reassign: null,
        type: null,
        feedback: [],
      },
      checkedIds: [],
      checkedAll: false,
      topCardList: [
        {
          name: this.$t("page.work-order.WorkOrdersThisMonth"),
          name1: this.$t("page.work-order.TotalWorkOrders"),
          value: 0,
          value1: 0,
          icon:' ri-file-text-line'
        },
        {
          name: this.$t("page.work-order.PendingAssignmentThisMonth"),
          name1: this.$t("page.work-order.TotalPendingAssignment"),
          value: 0,
          value1: 0,
          icon:' ri-send-plane-fill'

        },
        {
          name: this.$t("page.work-order.ClosedWorkOrdersThisMonth"),
          name1: this.$t("page.work-order.TotalClosedWorkOrders"),
          value: 0,
          value1: 0,
          icon:'ri-checkbox-circle-line'

        },
        {
          name: this.$t("page.work-order.CanceledWorkOrdersThisMonth"),
          name1: this.$t("page.work-order.TotalCanceledWorkOrders"),
          value: 0,
          value1: 0,
          icon:'ri-close-circle-line'

        },
      ],
    };
  },
  components: {
    TableLoading,
    WoStatusEtc,
    Layout,
    // PageHeader,
    Multiselect,
    feedbackFilter,
    CountTo,
  },
  computed: {
    visibleTableHeaders() {
      // 默认显示全部
      if (!this.showAllColumns) {
        return _.cloneDeep(this.tableHeaders);
      }
      // 根据点击的顺序展示
      return _.map(this.visibleFields, (fieldName) =>
          _.find(this.tableHeaders, ["name", fieldName])
      );
    },
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    //用于解析Table 工单类型
    orderTypeOptionsTxt(){
      let reslut = {}
      this.orderTypeOptions.map(item=>{
        reslut[item.value] = item.label
      })
      return reslut;
    }
  },
  mounted() {
    // this._getFirstPage()
    this.getStatisticsOrder()
    this._orderNum();

  },
  beforeRouteEnter(to, from, next) {
    routeFrom = from.name;
    next();
  },
  activated() {
    this.refresh(routeFrom === "work-order-detail");
  },
  methods: {
    getStatisticsOrder(){
      statisticsOrder().then((res) => {
        if (res && res.payload) {
          this.topCardList.map((item) => {
            if (item.name == this.$t("page.work-order.WorkOrdersThisMonth")) {
              item.value = res.payload["month_order"];
              item.value1 = res.payload["total_order"];
            }
            if (
                item.name ==
                this.$t("page.work-order.PendingAssignmentThisMonth")
            ) {
              item.value = res.payload["month_pending_assignment_order"];
              item.value1 = res.payload["total_pending_assignment_order"];
            }
            if (
                item.name ==
                this.$t("page.work-order.ClosedWorkOrdersThisMonth")
            ) {
              item.value = res.payload["month_closed_order"];
              item.value1 = res.payload["total_closed_order"];
            }
            if (
                item.name ==
                this.$t("page.work-order.CanceledWorkOrdersThisMonth")
            ) {
              item.value = res.payload["month_canceled_order"];
              item.value1 = res.payload["total_canceled_order"];
            }
          });
        }
      });
    },
    formatDatetime,
    getLabel(options, val) {
      if (!val) {
        return "";
      }
      const item = _.find(options, ["value", parseInt(val)]);
      if (!item) {
        return "";
      }
      return _.get(item, "label");
    },
    // 设置显示列
    changeShowAllColumns() {
      this.tableHeaders.forEach((i) => {
        i.visible = this.showAllColumns;
      });
      if (!this.showAllColumns) {
        this.visibleFields = [];
      } else {
        this.visibleFields = _.map(this.tableHeaders, "name");
      }
      
    },
    changeShowColumn(fieldName) {
      if(this.tableHeaders.every(header=>header.visible)){
        this.showAllColumns = true
      }else{
        this.showAllColumns = false
      }
      let result = []
      this.tableHeaders.map(item=>{
        if(item.visible){
          result.push(item.name)
        }
      })
      this.visibleFields = result

      // this.visibleFields = _.xor(this.visibleFields, [fieldName]);
    },
    checkAllChange() {
      if (this.checkedAll) {
        // 将所有ID追加到数组并去重
        this.checkedIds = _.uniq(
            _.concat(this.checkedIds, _.map(this.orders, "id"))
        );
      } else {
        this.checkedIds = [];
      }
    },
    checkChange(id) {
      this.checkedIds = _.xor(this.checkedIds, [id]);
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.count;
      let numberOfPages = Math.ceil(this.count / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    // 导出
    download() {
      // 当前的筛选条件：this.filters， 当前选择的字段：this.visibleTableHeaders

      const keyMap = {
        // priority: 'priority_txt',
        // status: 'status_txt',
        engineer: "main_engineer_txt",
      };
      // columns是一个字典，格式如：{key:title}，从this.visibleTableHeaders中获取name作为columns的key,label作为columns的title，且需要将priority,status的key转换为priority_txt,status_txt，engineer的key转换为main_engineer_txt
      let columns = _.map(this.visibleTableHeaders, (item) => {
        const key = keyMap[item.name] || item.name;
        return {
          [key]: item.label,
        };
      });
      columns = _.assign({}, ...columns);
      // param的格式如：{key:value}，从this.filters中获取key作为param的key,value作为param的value，删除page和page_size，删除value为null的key
      const param = _.omitBy(
          _.mapValues(this.filters, (value, key) => {
            if (key === "page" || key === "page_size") {
              return null;
            }
            return value;
          }),
          _.isNull
      );
      const langs = {
        type: WO_TYPE.reduce((obj, item) => {
          obj[item.value] = item.label;
          return obj;
        }, {}),
        priority: WorkOrderPriority.reduce((obj, item) => {
          obj[item.value] = item.label;
          return obj;
        }, {}),
        status: {
          ...WorkOrderStatus.reduce((obj, item) => {
            obj[item.value] = item.label;
            return obj;
          }, {}),
          5: this.$t("page.work-order.status.reassign"),
          6: this.$t("page.work-order.status.unconfirmed"),
          7: this.$t("page.work-order.status.under-construction"),
        },
      };
      const params = {
        params: param,
        columns,
        langs,
        tz: getTimezone(),
        file_name: this.$t("page.work-order-download-title"),
      };
      exportWorkOrder(params).then((res) => {
        window.open(
            "/service-report-download/" + res.payload.request_id + "?type=wo",
            "_blank",
            "noreferrer"
        );
      });
    },
    // 新建工单
    add() {
      this.$router.push({
        path:"/work-order-add/0",
        query: {
          create:true,
        },
      });
    },
    refresh(currentPage) {
      if (currentPage) {
        // 只刷新当前页，筛选条件和页码都不变
        this._getList();
      } else {
        // 刷新整个页面的数据
        this.filter_value.status = "0";
        this.resetSearch();
      }
    },
    // 筛选
    doFilter() {
      this.orders = [];
      const search = {
        keyword: null,
        created_at: null,
        priority: null,
        status: null,
        is_reassign: null,
        is_assigned: null,
        is_checkin: null,
        created_at_before: null,
        created_at_after: null,
        type: null,
        fb_quality_max: null,
        fb_quality_min: null,
        fb_attitude_max: null,
        fb_attitude_min: null,
        fb_response_speed_max: null,
        fb_response_speed_min: null,
        customer_status:null,
        is_rating:null,
      };
      if (this.filter_value.keyword) {
        search["keyword"] = this.filter_value.keyword;
      }
      if (this.filter_value.date) {
        search["created_at_before"] = this.filter_value.date;
        search["created_at_after"] = this.filter_value.date;
      }
      if (this.filter_value.priority) {
        search["priority"] = this.filter_value.priority;
      }
      if (this.filter_value.status) {
        // 待派工
        if (this.filter_value.status == 1) {

          if(this.user.user_type==='customer'){
            search["customer_status"] = 1
          }else{
            search["is_reassign"] = false;
            search["is_assigned"] = false;
            search["status"] = WO_STATUS_TO_BE_ASSIGNED;
            search["status"] = this.filter_value.status;

          }
        }
        // 待确认
        if (this.filter_value.status == 101) {
          search["status"] = WO_STATUS_TO_BE_ASSIGNED;
          search["is_assigned"] = true;
        }
        // 待转派
        if (this.filter_value.status == 100) {
          search["status"] = WO_STATUS_TO_BE_ASSIGNED;
          search["is_reassign"] = true;
        }
        // 待施工
        if (this.filter_value.status == 2) {
          if(this.user.user_type==='customer'){
            search["status"]=null
            search["customer_status"] = 2
          }else{
            search["is_checkin"] = false;
            search["status"] = this.filter_value.status;

          }
        }
        // 施工中
        if (this.filter_value.status == 102) {
          search["status"] = WO_STATUS_TO_BE_CONSTRUCTED;
          search["is_checkin"] = true;
        }
        if(this.filter_value.status == 3){
          if(this.user.user_type==='customer'){
            search["customer_status"] = 3
          }else{
            search["status"] = this.filter_value.status;
          }
        }
        if(this.filter_value.status == 4){
          if(this.user.user_type==='customer'){
            search["customer_status"] = 4
          }else{
            search["status"] = this.filter_value.status;
          }
        }
      }
      
      if (this.filter_value.type) {
        search["type"] = this.filter_value.type;
      }
      if (this.filter_value.feedback.length) {
        if (this.filter_value.feedback.includes("quality_bad")) {
          search["fb_quality_max"] = 2;
        }
        if (this.filter_value.feedback.includes("quality_good")) {
          search["fb_quality_min"] = 3;
        }
        if (this.filter_value.feedback.includes("attitude_bad")) {
          search["fb_attitude_max"] = 2;
        }
        if (this.filter_value.feedback.includes("attitude_good")) {
          search["fb_attitude_min"] = 3;
        }
        if (this.filter_value.feedback.includes("response_speed_bad")) {
          search["fb_response_speed_max"] = 2;
        }
        if (this.filter_value.feedback.includes("response_speed_good")) {
          search["fb_response_speed_min"] = 3;
        }
      }
      this.filters = _.assign(this.filters, search);
      this._getFirstPage();
    },
    // 重置
    resetSearch() {
      // this.filter_value.status = null
      this.filter_value.date = null;
      this.filter_value.priority = null;
      this.filter_value.keyword = null;
      this.filter_value.type = null;
      this.filter_value.feedback = [];
      this.doFilter();
    },
    // 状态筛选
    checkTab(val) {
      this.filter_value.status = val;
      this.doFilter();
    },
    // 翻页
    pageChange(val) {
      this.filters.page = val;
      this._getList();
    },
    // 设置每页条数
    pageSizeChange(val) {
      this.filters.page_size = val;
      this._getFirstPage();
    },
    // 获取数据
    _getFirstPage() {
      this.page = 1;
      this.filters.page = 1;
      this.checkedAll = false;
      this.checkedIds = [];
      this._getList();
      this._orderNum()
    },
    _getList() {
      this.filters.page_size = this.perPage;
      this.tableLoading = true;
      this.tableLoaded = false;
      this.orders = [];
      let params = this.filters
      /* 如果选择了待签字状态工单 */
      if(this.filter_value.status == 103){
        params =  _.assign({},this.filters,{
          status: 3,
          is_rating: false,
        })
      }
      /* 如果选择了完成状态工单 */ 
      if(this.filter_value.status == 3){
        params =  _.assign({},this.filters,{
          is_rating: true,
        })
      }
      workOrderList(params)
          .then((res) => {
            this.tableLoading = false;
            this.tableLoaded = true;
            this.orders = res.payload.results;
            this.count = res.payload.count;
            // 如果是全选状态，将当前页的所有ID追加到数组并去重
            if (this.checkedAll) {
              this.checkedIds = _.uniq(
                  _.concat(this.checkedIds, _.map(this.orders, "id"))
              );
            }
            // 获取服务商名称
            getCompany().then((companies) => {
              const companyNames = companies.reduce((obj, item) => {
                obj[String(item.id)] = item.name;
                return obj;
              }, {});
              this.orders = _.map(this.orders, (o) => {
                o.service_company_txt = companyNames[o.service_company];
                return o;
              });
            });
            this.getStatisticsOrder();

            this.setPages();
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 查待派工、待确认、待转派、待施工的工单数量
    _orderNum() {

      if(this.user.user_type==='customer'){
        const p = _.assign({}, this.filters,
            {
              page: 1,
              page_size: 10,
              customer_status: 1,
              date:this.filter_value.date,
              priority:this.filter_value.priority,
              keyword:this.filter_value.keyword,
              type:this.filter_value.type,
              feedback:this.filter_value.feedback,
            });
        // 待处理
        workOrderList({
          ...p,
          date:this.filter_value.date,
          priority:this.filter_value.priority,
          keyword:this.filter_value.keyword,
          type:this.filter_value.type,
          feedback:this.filter_value.feedback,
        }).then((res) => {

          this.tabOptions[1].tipNum = res.payload.count;

        });
        const p2 = _.assign({}, this.filters,
            {
              page: 1,
              page_size: 10,
              customer_status: 2,
              date:this.filter_value.date,
              priority:this.filter_value.priority,
              keyword:this.filter_value.keyword,
              type:this.filter_value.type,
              feedback:this.filter_value.feedback,
            });
        // 施工中
        workOrderList({
          ...p2,
          date:this.filter_value.date,
          priority:this.filter_value.priority,
          keyword:this.filter_value.keyword,
          type:this.filter_value.type,
          feedback:this.filter_value.feedback,
        }).then((res) => {

          this.tabOptions[2].tipNum = res.payload.count;

        });
        const p3 = _.assign({}, this.filters,
            {
              page: 1,
              page_size: 10,
              customer_status: 3,
              date:this.filter_value.date,
              priority:this.filter_value.priority,
              keyword:this.filter_value.keyword,
              type:this.filter_value.type,
              feedback:this.filter_value.feedback,
            });
        // 已完成
        workOrderList({
          ...p3,
          date:this.filter_value.date,
          priority:this.filter_value.priority,
          keyword:this.filter_value.keyword,
          type:this.filter_value.type,
          feedback:this.filter_value.feedback,
        }).then((res) => {

          this.tabOptions[4].tipNum = res.payload.count;

        });
        const p4 = _.assign({}, this.filters,
            {
              page: 1,
              page_size: 10,
              customer_status: 4,
              date:this.filter_value.date,
              priority:this.filter_value.priority,
              keyword:this.filter_value.keyword,
              type:this.filter_value.type,
              feedback:this.filter_value.feedback,
            });
        // 已取消
        workOrderList({
          ...p4,
          date:this.filter_value.date,
          priority:this.filter_value.priority,
          keyword:this.filter_value.keyword,
          type:this.filter_value.type,
          feedback:this.filter_value.feedback,
        }).then((res) => {

          this.tabOptions[5].tipNum = res.payload.count;

        });
        const p5 = _.assign({}, this.filters,
            {
              page: 1,
              page_size: 10,
              status: 3,
              is_rating: false,
              customer_status: null,
              date:this.filter_value.date,
              priority:this.filter_value.priority,
              keyword:this.filter_value.keyword,
              type:this.filter_value.type,
              feedback:this.filter_value.feedback,
            });
        // 待签字
        workOrderList({
          ...p5,
          date:this.filter_value.date,
          priority:this.filter_value.priority,
          keyword:this.filter_value.keyword,
          type:this.filter_value.type,
          feedback:this.filter_value.feedback,
        }).then((res) => {

          this.tabOptions[3].tipNum = res.payload.count;

        });
        
      }else{
        const p = _.assign({}, this.filters,
            {
              page: 1,
              page_size: 10,
              status: WO_STATUS_TO_BE_ASSIGNED,
              date:this.filter_value.date,
              priority:this.filter_value.priority,
              keyword:this.filter_value.keyword,
              type:this.filter_value.type,
              feedback:this.filter_value.feedback,
            });
        // 待派工
        workOrderList({
          ...p,
          is_reassign: false,
          is_assigned: false,
          is_checkin: null,
          date:this.filter_value.date,
          priority:this.filter_value.priority,
          keyword:this.filter_value.keyword,
          type:this.filter_value.type,
          feedback:this.filter_value.feedback,
        }).then((res) => {

          this.tabOptions[1].tipNum = res.payload.count;

        });
        // 待确认
        workOrderList({
          ...p,
          is_assigned: true,
          is_checkin: null,
          is_reassign: null,
          date:this.filter_value.date,
          priority:this.filter_value.priority,
          keyword:this.filter_value.keyword,
          type:this.filter_value.type,
          feedback:this.filter_value.feedback,
        }).then((res) => {
          this.tabOptions[2].tipNum = res.payload.count;


        });
        // 待转派
        workOrderList({
          ...p,
          is_reassign: true,
          is_assigned: null,
          is_checkin: null,
          date:this.filter_value.date,
          priority:this.filter_value.priority,
          keyword:this.filter_value.keyword,
          type:this.filter_value.type,
          feedback:this.filter_value.feedback,
        }).then((res) => {
          this.tabOptions[3].tipNum = res.payload.count;

        });
        const p1 = _.assign({}, this.filters, {
          page: 1,
          page_size: 10,
          status: 2,
          is_reassign: null,
          date:this.filter_value.date,
          priority:this.filter_value.priority,
          keyword:this.filter_value.keyword,
          type:this.filter_value.type,
          feedback:this.filter_value.feedback,
        });
        // 待施工
        workOrderList({
          ...p1,
          is_checkin: false,
          is_assigned: null,
          is_reassign: null,
          date:this.filter_value.date,
          priority:this.filter_value.priority,
          keyword:this.filter_value.keyword,
          type:this.filter_value.type,
          feedback:this.filter_value.feedback,
        }).then((res) => {

          if(this.user.user_type!=='customer'){
            this.tabOptions[4].tipNum = res.payload.count;

          }
        });
        // 施工中
        workOrderList({
          ...p1,
          is_checkin: true,
          is_assigned: null,
          is_reassign: null,
          date:this.filter_value.date,
          priority:this.filter_value.priority,
          keyword:this.filter_value.keyword,
          type:this.filter_value.type,
          feedback:this.filter_value.feedback,
        }).then((res) => {
          if(this.user.user_type==='customer'){
            this.tabOptions[2].tipNum = res.payload.count;

          }else{
            this.tabOptions[5].tipNum = res.payload.count;

          }
        });
        const p2 =  _.assign({}, this.filters, {
          page: 1,
          page_size: 10,
          status: 3,
          is_rating: false,
          is_assigned: null,
          is_reassign: null,
          date:this.filter_value.date,
          priority:this.filter_value.priority,
          keyword:this.filter_value.keyword,
          type:this.filter_value.type,
          feedback:this.filter_value.feedback,
        });
         // 待签字
         workOrderList({...p2}).then((res) => {
          if(this.user.user_type==='customer'){
            this.tabOptions[3].tipNum = res.payload.count;
          }else{
            this.tabOptions[6].tipNum = res.payload.count;
          }
        });
      }
    },
    // 每次筛选条件变化时，更新路由
    // _updateQuery() {
    //   console.log('更新路由')
    //   this.$router.push({
    //     path: this.$route.path,
    //     query: {
    //       ...this.$route.query,
    //       ...this.filters
    //     }
    //   })
    // },
  },
  // watch: {
  //   filters: {
  //     handler() {
  //       this._updateQuery()
  //     },
  //     deep: true
  //   }
  // },
};
</script>

<template>
  <Layout>
    <b-row v-if="user&&user.user_type!=='customer'">
      <b-col v-for="a in topCardList" :key="a.name" xxl="3" sm="6">
        <b-card no-body class="card-animate">
          <b-card-body>
            <div class="d-flex justify-content-between">
              <div>
                <p class="fw-medium text-muted mb-0">{{ a.name }}</p>
                <h2 class="mt-2 ff-secondary fw-semibold">
                  <count-to
                      :startVal="0"
                      :endVal="a.value"
                      :duration="5000"
                  ></count-to>
                </h2>
                <p class="mb-0 text-muted">
                  <b-badge class="bg-light mt-2 text-success mb-0 me-2">
                    {{ a.value1 }}
                  </b-badge>{{ a.name1 }}
                </p>
              </div>
              <div>
                <div class="avatar-sm flex-shrink-0">
                <span
                    class="avatar-title bg-soft-info text-info rounded-circle fs-4"
                >
                  <i :class="a.icon"></i>
                </span>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card no-body id="orderList">
          <b-card-header class="border-0">
            <b-row class="align-items-center gy-3">
              <b-col cols="sm">
                <h5 class="card-title mb-0">{{ title }}</h5>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex gap-1 flex-wrap">
                  <div class="btn-group" role="group">
                    <b-button
                        type="button"
                        variant="outline-primary"
                        class="ms-1 dropdown-toggle"
                        data-bs-toggle="dropdown"
                        id="btnGroup1"
                        aria-expanded="false"
                    >
                      <i class="ri-settings-3-line align-bottom me-1"></i>
                      {{ $t("page.set-column") }}
                    </b-button>
                    <ul class="dropdown-menu" aria-labelledby="btnGroup1">
                      <li class="dropdown-item accordion-button-class" @click.capture.stop>
                        <label>
                          <input
                              class="form-check-input"
                              type="checkbox"
                              v-model="showAllColumns"
                              @change="changeShowAllColumns"
                          />
                          {{ $t("base.select-all") }}
                        </label>
                      </li>
                      <li
                          v-for="(item, index) in tableHeaders"
                          :key="index"
                          class="dropdown-item accordion-button-class"
                          @click.capture.stop
                      >
                        <label>
                          <input
                              class="form-check-input"
                              type="checkbox"
                              v-model="item.visible"
                              @change="changeShowColumn(item.name)"
                          />
                          {{ item.label }}
                        </label>
                      </li>
                    </ul>
                  </div>

                  <b-button
                      type="button"
                      variant="primary"
                      class="ms-1"
                      @click="download"
                  >
                    <i class="ri-download-cloud-2-line align-bottom me-1"></i>
                    {{ $t("base.export") }}
                  </b-button>
                  <b-button
                      type="button"
                      variant="primary"
                      class="add-btn"
                      @click="add"
                      v-perm="'order.post'"
                  >
                    <i class="ri-add-line align-bottom me-1"></i>
                    {{ $t("base.add") }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body class="border border-dashed border-end-0 border-start-0">
            <b-form>
              <b-row class="g-3">
                <b-col xxl="3">
                  <div class="search-box">
                    <input
                        type="text"
                        class="form-control search"
                        v-model="filter_value.keyword"
                        :placeholder="`${$t('page.work-order.number')}/${$t(
                        'page.work-order.device-name'
                      )}/${$t('page.work-order.device-root-sn')}${(user&&user.user_type==='customer'?'':('/'+$t(
                  'page.customer_name'
                )))}/${$t('page.work-order.contact')}/${$t(
                        'page.work-order.contact-phone'
                      )}`"
                    />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </b-col>
                <b-col xxl="2">
                  <div>
                    <flat-pickr
                        :placeholder="$t('base.select-date')"
                        v-model="filter_value.date"
                        :config="config"
                        class="form-control flatpickr-input"
                    ></flat-pickr>
                  </div>
                </b-col>
                <b-col xxl="2">
                  <div class="input-light">
                    <Multiselect
                        class="form-control"
                        :placeholder="$t('page.work-order.type.text')"
                        v-model="filter_value.type"
                        :close-on-select="true"
                        :searchable="false"
                        :create-option="false"
                        :options="orderTypeOptions"
                        :can-clear="false"
                    />
                  </div>
                </b-col>
                <b-col xxl="2">
                  <div class="input-light">
                    <Multiselect
                        class="form-control"
                        :placeholder="$t('page.work-order.priority.text')"
                        v-model="filter_value.priority"
                        :close-on-select="true"
                        :searchable="false"
                        :create-option="false"
                        :options="priorityOptions"
                        :can-clear="false"
                    />
                  </div>
                </b-col>
                <!--       隐藏服务评价筛选         -->
                <b-col xxl="1">
                  <feedback-filter
                      v-model:value="filter_value.feedback"
                  ></feedback-filter>
                </b-col>

                <b-col xl="2" class="d-flex justify-content-end align-items-end">
                  <b-button
                      type="button"
                      variant="primary"
                      @click="doFilter"
                      class="me-2"
                  >
                    <i class="ri-search-line me-1 align-bottom"></i>
                    {{ $t("search") }}
                  </b-button>
                  <b-button type="button" variant="info" @click="resetSearch">
                    <i class="ri-restart-line me-1 align-bottom"></i>
                    {{ $t("base.reset") }}
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
          <b-card-body class="pt-0">
            <div>
              <ul
                  class="nav nav-tabs nav-tabs-custom nav-success mb-3"
                  role="tablist"
              >
                <li
                    class="nav-item"
                    v-for="(tabItem, index) in tabOptions"
                    :key="index"
                >
                  <b-link
                      class="nav-link py-3"
                      :class="
                     tabItem.value == filter_value.status ? 'active' : ''
                    "
                      data-bs-toggle="tab"
                      role="tab"
                      @click.prevent="checkTab(tabItem.value)"
                      aria-selected="true"
                  >
                    <i :class="tabItem.icon" class="me-1 align-bottom"></i>
                    {{ tabItem.text }}
                    <b-badge
                        v-if="tabItem.tipNum > 0"
                        variant="danger"
                        class="align-middle ms-1"
                    >{{ tabItem.tipNum }}</b-badge
                    >
                  </b-link>
                </li>
              </ul>

              <div class="table-responsive table-card mb-1">
                <table class="table table-nowrap align-middle" id="orderTable">
                  <thead class="text-muted table-light">
                  <tr class="text-uppercase">
                    <!--                      <th scope="col" style="width: 25px">-->
                    <!--                        <div class="form-check">-->
                    <!--                          <input class="form-check-input" type="checkbox"  v-model="checkedAll" @change="checkAllChange" />-->
                    <!--                        </div>-->
                    <!--                      </th>-->
                    <template
                        v-for="(item, index) in visibleTableHeaders"
                        :key="index"
                    >
                      <th v-show="item.visible">{{ item.label }}</th>
                    </template>
                  </tr>
                  </thead>
                  <tbody class="list form-check-all">
                  <tr v-for="(item, index) in orders" :key="index">
                    <!--                      <th scope="row">-->
                    <!--                        <div class="form-check">-->
                    <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
                    <!--                        </div>-->
                    <!--                      </th>-->
                    <template
                        v-for="(titleItem, titleIdx) in visibleTableHeaders"
                        :key="titleIdx"
                    >
                      <td v-show="titleItem.visible">
                        <wo-status-etc
                            v-if="
                              [
                                'priority',
                                'status',
                                'warranty_status',
                              ].includes(titleItem.name)
                            "
                            :value="item[titleItem.name]"
                            :field-name="titleItem.name"
                            :wo-data="item"
                        />
                        <router-link
                            v-else-if="titleItem.name == 'number'"
                            :to="'/work-order-detail/' + item['id']"
                        >{{ item[titleItem.name] }}</router-link
                        >
                        <span v-else-if="titleItem.name == 'type'">{{ orderTypeOptionsTxt&&orderTypeOptionsTxt[item['type']] }}</span>
                        <span v-else-if="titleItem.name == 'created_at'">{{
                            formatDatetime(item[titleItem.name])
                          }}</span>
                        <div class="d-flex align-items-center" v-else-if="titleItem.name == 'engineer'"
                        >
                          <div style="width:25px;text-align: start">{{ item.main_engineer_txt }}{{ item.assist_engineer_txt }}</div>
                          <div style="margin-left:60px;width:76px;height: 18px;border-radius: 20px;background: #6691E7;font-size: 12px;font-weight: 500;color:#FFFFFF;text-align: center"  v-if="(item.assist_engineer_txt||item.main_engineer_txt)&&item.service_company_type=='1'">{{ $t("page.work-order.factory_engineer") }}</div>
                          <div style="margin-left:60px;width: 76px;height: 18px;border-radius: 20px;background: #8698BC;font-size: 12px;font-weight: 500;color:#FFFFFF;text-align: center" v-if="(item.assist_engineer_txt||item.main_engineer_txt)&&item.service_company_type=='2'">{{ $t("page.work-order.authorized_engineer") }}</div>
                        </div>
                        <span v-else>{{ item[titleItem.name] }}</span>
                      </td>
                    </template>
                  </tr>
                  </tbody>
                </table>
                <table-loading
                    :count="count"
                    :table-loading="tableLoading"
                    :table-loaded="tableLoaded"
                ></table-loading>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <Pagination
        v-if="tab_info_length"
        v-model:page="page"
        v-model:perPage="perPage"
        :pages="pages"
        :prePageOption="prePageOption"
        :tab_info_length="tab_info_length"
        @update:page="pageChange"
        @update:perPage="pageSizeChange"
        class="me-5 my-3"
    ></Pagination>
  </Layout>
</template>
